import { api } from "@/shared/api";

// ── Types ──────────────────────────────────────────────────────────────

// local-only: A (frontend union); see proposals/2026-05-17-fe-generated-coverage-misc.md
export type PromptPresetScope = "kefu" | "peilian_customer" | "peilian_evaluator";
// local-only: A (frontend union)
export type PromptPresetType = "role" | "tone";

// local-only: B (backend schema gap) — /tenant/prompt-presets 返 presets 项
export interface PromptPresetItem {
  key: string;
  name: string;
  description: string;
  /** Role-only: tone keys that shouldn't be paired with this role. Empty for tones. */
  incompatible?: string[];
  meta?: Record<string, unknown>;
}

// local-only: B (backend schema gap) — /tenant/prompt-presets 返
export interface PromptPresetListResponse {
  presets: PromptPresetItem[];
  defaultKey: string;
}

// ── Service ────────────────────────────────────────────────────────────

export const promptPresetService = {
  list(scope: PromptPresetScope, type: PromptPresetType) {
    return api.get<PromptPresetListResponse>(`/tenant/prompt-presets?scope=${scope}&type=${type}`);
  },
};
